module.exports = {"aereoporto":{"label":"Bolzano","value":"BZO"},"andata":"20200118","ritorno":"20200124","camere":[{"adults":2,"childs":[0]},{"adults":2,"childs":[1,0]}]}


//////////////////
// WEBPACK FOOTER
// ./src/front/fake/search.json
// module id = J8lv
// module chunks = 9